var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShieldCheckIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 73,
    height: 84,
    viewBox: "0 0 73 84",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1602 41.0156C14.1602 28.856 24.2242 19.0156 36.6602 19.0156C49.0961 19.0156 59.1602 28.856 59.1602 41.0156C59.1602 53.1752 49.0961 63.0156 36.6602 63.0156C24.2242 63.0156 14.1602 53.1752 14.1602 41.0156Z",
    stroke: "#D70064",
    strokeWidth: 1.25,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.1602 40.9053L34.0935 47.0156L46.1602 35.0156",
    stroke: "#D70064",
    strokeWidth: 1.25,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3794 73.3135C7.16331 68.6021 1 62.0726 1 53.5295V15.7991C1 14.4698 2.05281 13.3555 3.50042 13.16C10.0585 12.2607 24.5785 8.56585 34.8434 1.31302C35.8962 0.57014 37.3876 0.57014 38.4405 1.31302C48.7053 8.56585 63.2253 12.2607 69.7834 13.16C71.231 13.3555 72.2838 14.4893 72.2838 15.7991V53.5295C72.2838 72.1405 42.9807 81.231 37.5193 82.7559",
    stroke: "#D70064",
    strokeWidth: 1.25,
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShieldCheckIcon);
export default __webpack_public_path__ + "static/media/shield-check-icon.d25414ad.svg";
export { ForwardRef as ReactComponent };